angular.module('avant.filters', []);
angular.module('avant.directives', []);
angular.module('avant.services', []);
angular.module('avant.i18n', []);
angular.module('angularAvant.controllers', []);
angular.module('angularAvant.custom', []);
angular.module('angularAvant.directives', []);
angular.module('avant.customerDashboard', []);
angular.module('avant.customer_applications.directives', []);
angular.module('angularAvant.resources', []);
angular.module('angularAvant.services', []);
angular.module('angularAvant.factories', []);
angular.module('angularAvant.filters', []);
angular.module('avant.conditionalAutoFocus', []);
angular.module('avant.constants', []);
angular.module('avant.contracts.services', []);
angular.module('avant.contracts', []);
angular.module('avant.controllers', []);
angular.module('avant.customer_applications.controllers', []);
angular.module('avant.customer_applications.factories', []);
angular.module('avant.customerSubmission', []);
angular.module('avant.interceptors', []);
angular.module('avant.kenshooReporter', []);
angular.module('avant.loadingSpinner', []);
angular.module('avant.products.services', []);
angular.module('avant.products', []);
angular.module('avant.trackingPixel', []);
angular.module('angular.extensions', []);
angular.module('avant.customer_applications.services', []);
angular.module('avant.googleTagManager', []);
angular.module('avant.mixpanel', []);
angular.module('avant.heap', []);
angular.module('avant.smartyStreets', []);
angular.module('avant.autocomplete', []);
angular.module('avant.tealium', []);
angular.module('angularAvant', [
  'ui.router',
  'avant.smartyStreets',
  'avant.heap',
  'ngCookies',
  'avant.mixpanel',
  'ngUpload',
  'mgcrea.ngStrap.strapmodal',
  'mgcrea.ngStrap.aside',
  'ui.bootstrap',
  'ui.slider',
  'ui.utils',
  'ui.select2',
  'ngAnimate',
  'snapscroll',
  'avant.filters',
  'avant.directives',
  'avant.services',
  'avant.i18n',
  'angularAvant.controllers',
  'angularAvant.custom',
  'avant.services',
  'angularAvant.directives',
  'avant.customerDashboard',
  'ui.bootstrap',
  'avant.i18n',
  'avant.customer_applications.directives',
  'angularAvant.resources',
  'angularAvant.services',
  'angularAvant.factories',
  'angularAvant.filters',
  'angularAvant',
  'ngUpload',
  'avant.conditionalAutoFocus',
  'avant.constants',
  'avant.contracts.services',
  'avant.contracts',
  'avant.controllers',
  'avant.customer_applications.controllers',
  'avant.customer_applications.factories',
  'avant.customerSubmission',
  'avant.customer_applications.services',
  'avant.filters',
  'avant.interceptors',
  'avant.kenshooReporter',
  'avant.loadingSpinner',
  'avant.products.services',
  'avant.products',
  'avant.trackingPixel',
  'angular.extensions',
  'avant.autocomplete',
  'avant.googleTagManager',
  'avant.scripts',
  'ui.slider',
  'pusher-angular',
  'avant.tealium',
]);
